import { Component, Input } from '@angular/core';

@Component({
  selector: 'mk-pulse',
  template: `<div class="sk-spinner sk-spinner-pulse" [style.background-color]="color"></div>`,
  styles: [`.sk-spinner-pulse{width:40px;height:40px;margin:40px auto;background-color:#333;border-radius:100%;-webkit-animation:1s ease-in-out infinite sk-pulseScaleOut;animation:1s ease-in-out infinite sk-pulseScaleOut}@-webkit-keyframes sk-pulseScaleOut{0%{-webkit-transform:scale(0);transform:scale(0)}100%{-webkit-transform:scale(1);transform:scale(1);opacity:0}}@keyframes sk-pulseScaleOut{0%{-webkit-transform:scale(0);transform:scale(0)}100%{-webkit-transform:scale(1);transform:scale(1);opacity:0}}`]
})
export class PulseComponent {
  @Input() color = '#da4733';
}
